// Analytics


analytics.eventConfig.push(
    {
        "target": ".component.s03-surfaced-item",
        "codeId": "s03",
        "events": [
            {
                "eventTarget": ".surfaced-item a:not([href*=\\http]), .surfaced-item .content-cta-overlay > a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "componentName": "surface item",
                    "componentId": "s03",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "surface item internal navigation click"
                        }
                    ],
                    "elementType": "surface item link",
                    "elementText": "",
                    "destinationUrl": "",
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".surfaced-item a[href*=\\http], .surfaced-item .content-cta-overlay > a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "componentName": "surface item",
                    "componentId": "s03",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "elementType": "surface item link",
                    "elementText": "",
                    "fileName": "",
                    "destinationUrl": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            }
        ]
    },

)